module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"th":{"action.user.update_profile":"แก้ไขข้อมูลผู้ใช้งาน","action.user.reset_password":"รีเซ็ตรหัสผ่าน","action.user.set_inactive":"ระงับการใช้งาน","action.user.set_active":"นำกลับมาใช้งาน"}}')
  delete Component.options._Ctor
}
